<p-confirmDialog key="resetpassword" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div style="margin: 5% 0px">
	<div *ngIf="Inited == false">
		<h4 style="text-align: center">...Loading</h4>
	</div>

	<div *ngIf="Inited == true && Disabled == false">
		<div class="PopupGrid2Col">
			<label>Username:</label>
			<label class="InfoText">{{ Username }}</label>

			<label>New Password:</label>
			<input type="password" class="form-control" [(ngModel)]="NewPassword" />

			<label>Confirm Password:</label>
			<input type="password" class="form-control" [(ngModel)]="ConfirmPassword" />
		</div>

		<div class="Buttons">
			<button [disabled]="Loading == true" class="btn btn-primary" (click)="onUpdate()">Update Password</button>
		</div>
	</div>

	<!--ErrorMessage-->
	<div *ngIf="ErrorMessage" class="TopMargin">
		<div name="ErrorMessage" class="alert alert-danger">
			{{ ErrorMessage }}
		</div>
	</div>
</div>
